import type { FaireThemeEntity } from "../../entity_types/theme";

export const waterproof_glamour: FaireThemeEntity = {
  token: "waterproof-glamour",
  type: "theme",
  name: "Waterproof Glamour",
  description: "CZ-accented, fully water-resistant pieces perfect for the active California lifestyle.",
  teaser: "Life-proof jewelry for the California lifestyle -- beach to brunch.",
  detail: "California location means customers benefit from life-proof jewelry that handles the coastal environment. All five products -- including Eclaire Station Necklace and Doree Studs -- are water-resistant and hypoallergenic.",
  bgColor: "#F5D6D6",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ar6ja253qt",
    "p_pqf2f49nzz",
    "p_dvc55z5255",
    "p_ut3tbs6mrw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
